module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_37.dot-c8ae4f01bd5c76761b55e945c74e0962.svg";